import { InputProps } from "antd";
import React, { useState, useEffect } from "react";
import { DefaultInput } from "../DefaultInput";

interface NumberInputProps extends InputProps {
  maxDecimals?: number;
  allowNegative?: boolean;
}

export const NumberInput: React.FC<NumberInputProps> = (props) => {
  const { maxDecimals, allowNegative, ...restProps } = props;
  const [value, setValue] = useState<string>(props.defaultValue?.toString() || props.value?.toString() || "");

  useEffect(() => {
    if (props.value !== undefined && props.value?.toString() !== value) {
      setValue(props.value.toString());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    let newValue = inputValue.replace(/,/g, ".");

    const sign = allowNegative && newValue.trimStart().startsWith("-") ? "-" : "";
    let body = newValue.replace(/[^\d.]/g, "");

    const parts = body.split(".");
    if (parts.length > 2) {
      body = parts[0] + "." + parts.slice(1).join("");
    }

    // Ограничиваем количество знаков после запятой, если указан maxDecimals
    const limitedParts = body.split(".");
    if (maxDecimals !== undefined && limitedParts.length === 2 && limitedParts[1].length > maxDecimals) {
      body = limitedParts[0] + "." + limitedParts[1].slice(0, maxDecimals);
    }

    newValue = sign + body;

    setValue(newValue);

    if (props.onChange) {
      const syntheticEvent = {
        ...e,
        target: {
          ...e.target,
          value: newValue,
        },
      };
      props.onChange(syntheticEvent as React.ChangeEvent<HTMLInputElement>);
    }
  };

  const { value: _, defaultValue: __, ...inputProps } = restProps;

  return <DefaultInput {...inputProps} value={value} onChange={handleChange} />;
};
